import { render } from "../templates/tree-item.html?vue&type=template&id=ed4121da"
import script from "./tree-item.vue?vue&type=script&lang=js"
export * from "./tree-item.vue?vue&type=script&lang=js"

import "./tree-item.vue?vue&type=style&index=0&id=ed4121da&lang=scss"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__